module.exports = __webpack_public_path__ + "img/69_16.e33352de.png";